<div class="container col-12 col-xxl-10 powerBI-frame-container p-0">
    <div [ngClass]="!isMobileDevice ? 'powerBI-frame' : ''" [ngStyle]="isMobileDevice ? getClassForMobileView() : ''" class="position-relative powerBI-frame">
      <div #frameContainer class="position-absolute frame"></div>
  </div>
</div>
